// Chapter 6 writing frames ("מסגרות"), uploaded 30.10.2026 (Shlomo reviews them live on the site).
// One frame per step; all work on the single event the reader names in step 1.
// Mounted by App.tsx (FrameBox) at <div data-widget-anchor="ch6_fN"> in src/chapters/chapter-6.html.
// Answers persist in progress.fields under `${id}_${i}` (or `_c1`/`_c2` for two columns).
import type { Frame } from "./frames";

export const CH6_FRAMES: Frame[] = [
  {
    "id": "ch6_f1",
    "n": "6.1",
    "title": "המראה שלי",
    "type": "lines",
    "intro": "עובדות בלבד, בלי פרשנות. אין תשובה נכונה.",
    "fields": [
      "השם שנתתי למראה:",
      "מי, ומה הוא עשה (מה שמצלמה הייתה רואה):",
      "המילה שנתתי לו בראש (התכונה):",
      "מה הרגשתי, ובאיזו עוצמה (1-10):"
    ]
  },
  {
    "id": "ch6_f2",
    "n": "6.2",
    "title": "מה המראה שלי מחזירה",
    "type": "choice5",
    "intro": "סמני אחד, ואז מילה אחת:",
    "fields": [
      "ציפייה · פחד · פצע ישן · ערך שלי",
      "מה נחשף אצלי, במילה או שתיים:"
    ]
  },
  {
    "id": "ch6_f3",
    "n": "6.3",
    "title": "טבלת השמות",
    "type": "existing",
    "intro": "שורה אחת מתחת לטבלה שמילאת:",
    "fields": [
      "האדם מהמראה שלי הוא מספר ___ בטבלה / לא בטבלה, ולמה:"
    ]
  },
  {
    "id": "ch6_f4",
    "n": "6.4",
    "title": "טבלת התכונות והצבעים",
    "type": "existing",
    "intro": "שורה אחת מתחת לטבלת התכונות שמילאת:",
    "fields": [
      "המילה מצעד 1 (או ההפך שלה) בטבלה: הצבע, ואצל מי מהחמישה הופיעה:"
    ]
  },
  {
    "id": "ch6_f5",
    "n": "6.5",
    "title": "לוח הסרגלים",
    "type": "existing",
    "intro": "שורה אחת מתחת ללוח הסרגלים שמילאת:",
    "fields": [
      "הסרגל של המראה שלי, במילים שלי (קצה חיובי - קצה שלילי):"
    ]
  },
  {
    "id": "ch6_f6",
    "n": "6.6",
    "title": "הפער על הסרגל שלי",
    "type": "scale2",
    "intro": "1 = הקצה השלילי של הסרגל שלי, 10 = הקצה החיובי.",
    "fields": [
      "איפה אני על הסרגל הזה",
      "איפה מיקמתי את המעשה שלו",
      "כמה פעמים הסרגל הזה חזר אצלי בטבלה, ומה זה אומר לי:"
    ]
  },
  {
    "id": "ch6_f7",
    "n": "6.7",
    "title": "סכנה, או כעס מוצדק",
    "type": "lines",
    "intro": "",
    "fields": [
      "הנורית האדומה אמרה לי:",
      "סכנת חיים? (כן / לא) ומה באמת היה שם:",
      "הצעד המחושב שלי (או: להמשיך בדרכי, ובשקט):"
    ]
  },
  {
    "id": "ch6_f8",
    "n": "6.8",
    "title": "המשפט החדש, ושלוש האצבעות",
    "type": "twocol_named",
    "intro": "",
    "fields": [
      "המשפט הישן (\"אתה...\")|המשפט החדש (\"באמצעותך אני מזהה את...\")",
      "שלוש האצבעות: מה אצלי מבקש טיפול:",
      "האגודל: מה יכול לצמוח מזה:",
      "תודה למראה, ושחרור (משפט אחד):"
    ]
  },
  {
    "id": "ch6_f9",
    "n": "6.9",
    "title": "אותו אירוע, שני סרגלים",
    "type": "twocol",
    "intro": "",
    "fields": [
      "מה אני ראיתי (דרך הסרגל שלי)|מה הוא או היא היו רואים (סרגל אחר, או אף סרגל)"
    ]
  },
  {
    "id": "ch6_f10",
    "n": "6.10",
    "title": "שש השאלות על המראה שלי",
    "type": "lines",
    "intro": "",
    "fields": [
      "1. מה בדיוק תחושתי והרגשתי:",
      "2. מה אינני מקבלת אצל הזולת (כלומר, בעצמי):",
      "3. מה מפחיד אותי, מה תוקע אותי, מה מקור ההתנגדות:",
      "4. איזה סרגל שלי מופעל:",
      "5. מה הייתי רוצה לקבל בעצמי שזיהיתי אצל האחר:",
      "6. המתנה הקטנה מהמראה הזאת, מה היא לימדה אותי על עצמי:"
    ]
  },
  {
    "id": "ch6_f11",
    "n": "6.11",
    "title": "המראה שלי, מתוך קבלה",
    "type": "final",
    "intro": "",
    "fields": [
      "המראה שלי, טייק שני (שלוש שורות, מתוך קבלה של עצמי ושלו):",
      "",
      "",
      "המשפט שלי לפעם הבאה שהסרגל הזה יידלק:",
      "מתי אמלא את הטבלאות שוב (חודש / תאריך):"
    ]
  }
];
